"use strict";
function initVerticalGallery() {
    const wrapper = document.querySelector('.vertical-gallery-wrapper');
    if (!wrapper)
        return;
    const thumbs = wrapper.querySelectorAll('.vg-thumb-item');
    const mains = wrapper.querySelectorAll('.vg-main-item');
    thumbs.forEach(thumb => {
        thumb.removeEventListener('click', function () { });
        thumb.addEventListener('click', function () {
            thumbs.forEach(t => t.classList.remove('is-active'));
            mains.forEach(m => m.classList.remove('is-active'));
            this.classList.add('is-active');
            const targetId = this.getAttribute('data-media-id');
            const targetMain = document.getElementById(`Media-${targetId}`);
            if (targetMain)
                targetMain.classList.add('is-active');
        });
    });
    thumbs[0]?.click();
    // --- Helper: build media list and find index for a given mainItem ---
    function openLightboxAt(mainItem) {
        const activeMain = wrapper.querySelector('.vg-main-item.is-active');
        const activeColor = activeMain ? activeMain.getAttribute('data-color') : null;
        const visibleMains = activeColor
            ? wrapper.querySelectorAll(`.vg-main-item[data-color="${activeColor}"]`)
            : wrapper.querySelectorAll('.vg-main-item.is-active');
        const mediaList = [];
        let startIndex = 0;
        visibleMains.forEach(function (m) {
            const deferred = m.querySelector('deferred-media');
            const mImg = m.querySelector('.product-media__image');
            if (!mImg) return;
            if (m === mainItem) startIndex = mediaList.length;
            if (deferred) {
                const tpl = deferred.querySelector('template');
                mediaList.push({ src: mImg.currentSrc || mImg.src, highRes: '', type: 'video', videoHtml: tpl ? tpl.innerHTML : '' });
            } else {
                const src = mImg.currentSrc || mImg.src;
                const highRes = mImg.getAttribute('data-max-resolution') || src;
                mediaList.push({ src: src, highRes: highRes, type: 'image', videoHtml: '' });
            }
        });
        if (typeof ImageZoomLightbox !== 'undefined' && mediaList.length > 0) {
            ImageZoomLightbox.open(mediaList, startIndex);
        }
    }

    // --- Click main image to open zoom lightbox ---
    mains.forEach(mainItem => {
        const img = mainItem.querySelector('.product-media__image');
        if (!img) return;
        img.addEventListener('click', function () { openLightboxAt(mainItem); });
    });
}
